import React, { ReactElement } from 'react';
import { ModalDialogueContext, ModalDialogueWindow } from 'idsk-react-components';
import { HistoryContext, ResponsiveContext } from 'slovlex-idsk-react-components';
import TezauryRouter from './routing/TezauryRouter';
import { SuccessMessageContextProvider } from './context/SuccessMessageContext';
import { ClientStatusContextProvider } from './context/ClientStatusContext';
import ScrollToTop from './module/ScrollToTop';
import './main.scss';
import { UserContextProvider } from './context/UserContext';
import { SecurityContextProvider } from './context/SecurityContext';

const App = (): ReactElement => (
  <ModalDialogueContext>
    <SuccessMessageContextProvider>
      <ResponsiveContext maxDesktopValuePx={640}>
        <ModalDialogueWindow />
        <SecurityContextProvider>
          <ClientStatusContextProvider>
            <UserContextProvider>
              <HistoryContext>
                <ScrollToTop />
                <TezauryRouter />
              </HistoryContext>
            </UserContextProvider>
          </ClientStatusContextProvider>
        </SecurityContextProvider>
      </ResponsiveContext>
    </SuccessMessageContextProvider>
  </ModalDialogueContext>
);

export default App;
